import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/novias',
      name: 'novias',
      component: () => import('./views/Novias.vue')
    },
    {
      path: '/fiesta',
      name: 'fiesta',
      component: () => import('./views/Fiesta.vue')
    },
    {
      path: '/complementos',
      name: 'complementos',
      component: () => import('./views/Complementos.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
